import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { INVESTMENT_API } from "./apiRoutes";

const mutateAddStrategicInvestment = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${INVESTMENT_API}/`, data);
};

const useAddStrategicInvestmentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddStrategicInvestment,
    ...queryParams,
  });

export default useAddStrategicInvestmentMutation;
